import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { Group, GroupsContainerState } from './groups';

const initialState: GroupsContainerState = {
  listGroups: [],
  page: 0,
  pageSize: 20,
  total: 0,
  isFetching: false,
  search: '',
};

export const groupsSlice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setListGroups: (state, action: PayloadAction<Group[]>) => {
      state.listGroups = action.payload;
    },
    addGroups: (state, action: PayloadAction<Group[]>) => {
      state.listGroups = state.listGroups.concat(action.payload);
      state.total += action.payload.length;
    },
    deleteGroup: (state, action: PayloadAction<string>) => {
      state.listGroups = state.listGroups.filter(
        (s) => s.id !== action.payload,
      );
      state.total = state.total - 1;
    },
    updateGroupById: (state, action: PayloadAction<Group>) => {
      const index = state.listGroups.findIndex(
        (s) => s.id === action.payload.id,
      );
      if (index !== -1) {
        const group = state.listGroups[index];
        Object.assign(group, action.payload);
        state.listGroups[index] = group;
      }
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setActiveGroup: (state, action: PayloadAction<Group | undefined>) => {
      state.activeGroup = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setIsFetching: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
    },
  },
});

export const {
  setListGroups,
  addGroups,
  deleteGroup,
  updateGroupById,
  setPage,
  setActiveGroup,
  setSearch,
  setTotal,
  setIsFetching,
} = groupsSlice.actions;

export default groupsSlice.reducer;
